export default "__VITE_ASSET__DOiJZ4I4__"